function setCookie(key, value) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (3 * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

$(document).ready(function($) {
    setTimeout(function() {
        if (!getCookie('cookie-policy')) {
            $('body').addClass('cookies-active');
            $('.js-cookies').fadeIn(500);
        }
    }, 2000);

    $('.js-accept-cookies').on('click', function() {
        $('body').removeClass('cookies-active');
        $('.js-cookies').fadeOut(500);
        setCookie('cookie-policy', 'accepted');
    })
})
